<template>
  <span
    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
    :class="outcomeClasses"
  >
    <slot>{{ outcome?.replace("_", " ") }}</slot>
  </span>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  outcome: {
    type: String,
    required: true,
  },
});

const outcomeClasses = computed(() => {
  const classes = {
    reached: "bg-green-100 text-green-800",
    not_reachable: "bg-gray-100 text-gray-800",
    wrong_number: "bg-red-100 text-red-800",
    denied_relationship: "bg-orange-100 text-orange-800",
    confirmed: "bg-green-100 text-green-800",
    no_answer: "bg-yellow-100 text-yellow-800",
    busy: "bg-yellow-100 text-yellow-800",
    call_back_later: "bg-blue-100 text-blue-800",
    language_barrier: "bg-purple-100 text-purple-800",
    deceased: "bg-gray-800 text-white",
    other: "bg-gray-100 text-gray-800",
  };

  return classes[props.outcome] || "bg-gray-100 text-gray-800";
});
</script>
